module.exports = __webpack_public_path__ + "assets/img/1481587607628_.pic_hd.f19662e7.jpg";